import { action } from "typesafe-actions";

import {
  IDashboardActionTypes,
  IDetail,
  IDisplayFormat,
  IFilters,
  IFiltersDetail,
  IPoliticalGroup,
  IResults,
} from "./Types";

export const getPoliticalGroup = (
  token: string,
  political_regime_id?: number
) => {
  return action(IDashboardActionTypes.GET_POLITICAL_GROUP, [
    token,
    political_regime_id,
  ]);
};
export const getPoliticalGroupSuccess = (
  politicalGroupList: IPoliticalGroup[]
) => {
  return action(
    IDashboardActionTypes.GET_POLITICAL_GROUP_SUCCESS,
    politicalGroupList
  );
};
export const getPoliticalGroupError = (error: string) => {
  return action(IDashboardActionTypes.GET_POLITICAL_GROUP_ERROR, error);
};
export const getDashboard = (filters: IFilters) => {
  return action(IDashboardActionTypes.GET_DASHBOARD, filters);
};
export const getDashboardSuccess = (results: IResults) => {
  return action(IDashboardActionTypes.GET_DASHBOARD_SUCCESS, results);
};
export const getDashboardError = (results: any) => {
  return action(IDashboardActionTypes.GET_DASHBOARD_ERROR, results);
};
export const getDateCloture = (token: string) =>
  action(IDashboardActionTypes.GET_DATE_CLOTURE, token);
export const getDateClotureSuccess = (date: Date) =>
  action(IDashboardActionTypes.GET_DATE_CLOTURE_SUCCESS, date);

export const buildColumns = () => action(IDashboardActionTypes.BUILD_COLUMNS);
export const buildDataHMS = () => action(IDashboardActionTypes.BUILD_DATA_HMS);
export const buildDataPercent = () =>
  action(IDashboardActionTypes.BUILD_DATA_PERCENT);
export const buildDataMonthHMS = () =>
  action(IDashboardActionTypes.BUILD_DATA_MONTH_HMS);
export const buildDataMonthPercent = () =>
  action(IDashboardActionTypes.BUILD_DATA_MONTH_PERCENT);
export const setDisplayFormat = (displayFormat: IDisplayFormat) =>
  action(IDashboardActionTypes.SET_DISPLAY_FORMAT, displayFormat);

export const getDashboardDetail = (filters: IFiltersDetail) => {
  return action(IDashboardActionTypes.GET_DASHBOARD_DETAIL, filters);
};
export const getDashboardDetailSuccess = (results: IDetail[]) => {
  return action(IDashboardActionTypes.GET_DASHBOARD_DETAIL_SUCCESS, results);
};
export const resetData = () => action(IDashboardActionTypes.RESET_DATA, []);
export const initializeData = () =>
  action(IDashboardActionTypes.INITIALIZE_DATA, []);

export const getAutocompleteEmission = (
  emission_name: string,
  media_ids?: number[]
) =>
  action(IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE, {
    emission_name,
    media_ids,
  });
export const getAutocompleteEmissionSuccess = (emissions: string[]) =>
  action(IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE_SUCCESS, emissions);
export const getAutocompleteEmissionError = (error: any) =>
  action(IDashboardActionTypes.GET_EMISSION_AUTOCOMPLETE_ERROR, error);
export const clearEmissionList = () =>
  action(IDashboardActionTypes.CLEAR_EMISSION_LIST, []);
